export default __webpack_public_path__ + "static/media/10 00_00_00-00_58_00.10aa9c9f.mp4";